<template>
  <div  id="chooseAddGoods">
      <div class="invoicingHead" style="height:40px;">
        <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <a @click="goBack" href="javascript:;">选择商品</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item>新增商品</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="searchGroup" >
        <el-form ref="ruleForm" :model="ruleForm" label-width="100px">
            <el-form-item label="商品名称：">
              <el-input v-model="ruleForm.goodsName" autofocus="true" style="width:480px" maxlength="10" placeholder="输入商品名称"></el-input>
            </el-form-item>
            <el-form-item label="图片附件：(最多六张)">
                <el-upload
                    action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :http-request="loadImg"
                    :class="{hide:hideUpload}"
                    :on-change="handleEditChange"
                    :limit="6">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
            <el-form-item label="选择分类：">
                <el-select v-model="ruleForm.goodsCategoryId" placeholder="请选择">
                    <el-option v-for="item in goodsCategoryList" :key="item.goodsCategoryId" :label="item.categoryName" :value="item.goodsCategoryId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品描述：">
              <el-input  v-model="ruleForm.goodsDescription" style="width:480px;" placeholder="输入商品描述" type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="商品规格：">
              <el-button type="primary" plain @click="addGoodsSpecification">添加商品规格</el-button>
              <el-button type="primary" @click="jumpTT('/invoicingFather/addUnitManagement')">单位管理</el-button>
            </el-form-item>
            <el-form-item label="">
              <div class="specification" v-for="(item,index) in productsList" :key="index">
                <div class="flex-betweens">
                  <div class="flex-between">
                    <div>商品规格</div>
                    <div><el-input v-model="item.valueContent" style="width: 100px;" placeholder="商品规格"></el-input></div>
                  </div>
                  <div class="flex-between">
                    <div>零售价（元）</div>
                    <div><el-input v-model="item.retailPrice" style="width: 100px;" placeholder="零售价" type="number" @blur="retailPriceBlur(item, index)"></el-input></div>
                  </div>
                  <div class="flex-between">
                    <div>划线价（元）</div>
                    <div><el-input v-model="item.costPrice" style="width: 100px;" placeholder="划线价" type="number" @blur="costPriceBlur(item, index)"></el-input></div>
                  </div>
                  <div class="flex-between">
                    <div>会员价（元）</div>
                    <div><el-input v-model="item.memberPrice" style="width: 100px;" placeholder="会员价" type="number" @blur="memberPriceBlur(item, index)"></el-input></div>
                  </div>
                  <div class="flex-between">
                    <div>参考进货价（元）</div>
                    <div><el-input v-model="item.takePrice" style="width: 100px;" placeholder="进货价" type="number" @blur="takePriceBlur(item, index)"></el-input></div>
                  </div>
                  <div class="flex-between">
                    <div>商品单位</div>
                    <div>
                      <el-select v-model="item.goodsUnitId" style="width: 110px;" placeholder="商品单位">
                        <el-option v-for="item in unitsList" :key="item.goodsUnitId" :label="item.goodsUnit" :value="item.goodsUnitId"></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="flex-between">
                    <div>商品条码</div>
                    <div><el-input v-model="item.barCode" style="width: 100px;" type="number" placeholder="商品条码"></el-input></div>
                  </div>
                </div>
                <div class="flex-start mt20">
                  <div class="flex-start">
                    <div><el-radio v-model="item.isInfiniteStock" label="无限库存"></el-radio></div>
                    <div class="ml30">
                      <el-radio v-model="item.isInfiniteStock" label="自定义库存"></el-radio>
                      <el-input v-model="item.beginStockNum" style="width: 100px;" @blur="beginStockNumBlur(item, index)" type="number" placeholder="自定义库存" v-if="item.isInfiniteStock == '自定义库存'"></el-input>
                    </div>
                  </div>
                  <div class="ml140">
                    库存预警<img class="warn" src="../../assets/icon/jjb.png"/>
                    <span>
                      <el-input v-model="item.minimumTotalStockCount" style="width: 110px;" placeholder="最低库存量"></el-input>
                      <el-input v-model="item.maximumTotalStockCount" style="width: 110px;" placeholder="最高库存量"></el-input>
                    </span>
                  </div>
                  <div class="ml90" v-show="deleteShow"><el-button type="text" @click="deleteSpecification(index)">删除</el-button></div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="填写备注：">
              <el-input placeholder="输入备注信息" type="textarea" style="width:480px;" v-model="ruleForm.goodsRemark"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveForm">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
import { uploadImg, goodsCategoryLists, goodsUnitList, createOrUpdateGoods } from "../api"
export default {
    data() {
        return {
            userList: {},
            ruleForm: {
              goodsName: "",
              goodsCategoryId: "",
              goodsDescription: "",
              goodsRemark: "",
              goodsImages: ""
            },
            dialogImageUrl: '',
            dialogVisible: false,
            hideUpload: false,
            goodsCategoryId: "",
            goodsCategoryList: [],
            unitsList: [],
            productsList: [
              {
                valueContent: "",
                retailPrice: "",
                takePrice: "",
                costPrice: "",
                memberPrice: "",
                barCode: "",
                isInfiniteStock: "",
                maximumTotalStockCount: "",
                maximumTotalStockCount: "",
                beginStockNum: "",
                goodsUnitId: "",
              }
            ],
            deleteShow: false
        }
    },
    created() {
        let userList = JSON.parse(this.getCookie("userList"));
        this.userList = userList;
        console.log(this.$route.query.form)
        this.getGoodsCategoryList()
    },
    methods: {
        //跳转
        jumpTT(adress, message) {
          this.$router.push({ path: adress, query: { docId: message } });
        }, 
        goBack() {
          this.$router.push({ path: '/invoicingFather/chooseGoods', query: { goodsStyle: localStorage.getItem("goodsStyle")}})
        },
        // 移除
        handleRemove(file, fileList) {
            this.hideUpload = fileList.length >= 6
        },
        // 放大
        handlePictureCardPreview(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        },
        // 上传商品图片
        loadImg(res) {
            let imgUploadForm = new FormData();
            imgUploadForm.append("file", res.file);
            imgUploadForm.append("fileContentType", res.file.type);
            imgUploadForm.append("fileFileName", res.file.name);
            imgUploadForm.append("isCompre", 1);
            imgUploadForm.append("isCutImage", 1);
            console.log(imgUploadForm, "imgUploadForm")
            uploadImg(imgUploadForm)
            .then(res => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.ruleForm.goodsImages += res.data.data.url + ','
                this.ruleForm.goodsImages= this.ruleForm.goodsImages.substring(0, this.ruleForm.goodsImages.lastIndexOf(','))
                this.dialogImageUrl = res.data.data.url;
              } else if (res.data.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(res => {}); 
        },
        handleEditChange (file, fileList) {
          this.hideUpload = fileList.length >= 6
        },
        // 获取分类列表
        getGoodsCategoryList() {
            goodsCategoryLists({
                sessionId: this.userList.sessionId,
                userId: this.userList.id,
                isManager: 1,
                queryType: 2,
                pageNo: 1,
                row: 999999,
                shopStoreId: localStorage.getItem("shopStoreId")
            })
            .then(res =>{
                if (res.code == 1) {
                    this.goodsCategoryList = res.data 
                    this.ruleForm.goodsCategoryId = res.data[0].goodsCategoryId
                    this.getGoodsUnitList()
                }
            })
        },
        // 获取单位列表
        getGoodsUnitList() {
          goodsUnitList({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            isManager: 1,
            pageNo: 1,
            row: 999999
          })
          .then(res => {
            if (res.code == 1) {
              this.unitsList = res.data
              for (var i in this.unitsList) {
                if (this.unitsList[i].unitType == 1) {
                  this.unitsList[i].goodsUnit = this.unitsList[i].goodsUnit + " " + "(计数）"
                } else if (this.unitsList[i].unitType == 2) {
                  this.unitsList[i].goodsUnit = this.unitsList[i].goodsUnit + " " + "(计重）"
                }
              }
            }
          })
        },
        // 保存
        saveForm() {
          console.log(this.ruleForm)
          var products = [];
          for (var i = 0; i < this.productsList.length; i++) {
            if (this.ruleForm.goodsName == "") {
              this.$message.error("请输入商品名称")
              return
            } else if (this.productsList[i].retailPrice == "") {
              this.$message.error("请输入零售价")
              return
            } else if (this.productsList[i].goodsUnitId == "") {
              this.$message.error("请选择单位")
              return
            } else if (this.productsList[i].isInfiniteStock == "") {
              this.$message.error("请选择是否无限库存")
              return
            } else if (this.productsList[i].valueContent == "") {
              this.$message.error("请输入商品规格")
              return
            } else if (Number(this.productsList[i].retailPrice) < Number(this.productsList[i].memberPrice)) {
              this.$message.error("会员价不能高于零售价哦");
              return;
            } else if (Number(this.productsList[i].maximumTotalStockCount) < Number(this.productsList[i].minimumTotalStockCount)) {
              this.$message.error("最低库存量不能高于最高库存量哦");
              return;
            }
            products.push({
              valueContent: this.productsList[i].valueContent,
              retailPrice:  this.productsList[i].retailPrice,
              costPrice: this.productsList[i].costPrice,
              memberPrice: this.productsList[i].memberPrice,
              qrcStockCount: this.productsList[i].beginStockNum,
              barCode: this.productsList[i].barCode,
              takePrice: this.productsList[i].takePrice,
              goodsUnitId: this.productsList[i].goodsUnitId,
              isInfiniteStock: this.productsList[i].isInfiniteStock == "无限库存" ? 1 : 0,
              minimumTotalStockCount: this.productsList[i].minimumTotalStockCount,
              maximumTotalStockCount: this.productsList[i].maximumTotalStockCount
            });
          }
          products = JSON.stringify(products);
          createOrUpdateGoods({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            isManager: 1,
            goodsImages: this.ruleForm.goodsImages,
            goodsName: this.ruleForm.goodsName,
            goodsCategoryId: this.ruleForm.goodsCategoryId,
            goodsDescription: this.ruleForm.goodsDescription,
            goodsRemark: this.ruleForm.goodsRemark,
            products
          })
          .then(res => {
            if (res.code == 1) {
              this.$message.success(res.msg)
              this.$router.push("/invoicingFather/chooseGoods")
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(error => {
            this.$message.error(error.msg)
          })
        },
        // 添加商品规格
        addGoodsSpecification() {
          this.productsList.push({
            valueContent: "",
            retailPrice: "",
            takePrice: "",
            costPrice: "",
            memberPrice: "",
            barCode: "",
            isInfiniteStock: "",
            maximumTotalStockCount: "",
            maximumTotalStockCount: "",
            beginStockNum: "",
            goodsUnitId: ""
          })
          if (this.productsList.length >= 2) {
            this.deleteShow = true
          }
        },
        // 删除
        deleteSpecification(index) {
          console.log(index)
          this.productsList.splice(index, 1)
          if (this.productsList.length == 1) {
            this.deleteShow = false
          }
        },
        // 零售价
        retailPriceBlur(item, index) {
          console.log(item, index)
          if (item.retailPrice == 0) {
            this.$message.error("零售价不能为0")
            this.productsList[index].retailPrice = ""
            return
          }
          this.productsList[index].retailPrice = Number(item.retailPrice).toFixed(2)
        },
        // 划线价
        costPriceBlur(item, index) {
          if (item.costPrice == 0) {
            this.$message.error("划线价不能为0")
            this.productsList[index].costPrice = ""
            return
          }
          this.productsList[index].costPrice = Number(item.costPrice).toFixed(2)
        },
        // 会员价
        memberPriceBlur(item, index) {
          if (item.memberPrice == 0) {
            this.$message.error("会员价不能为0")
            this.productsList[index].memberPrice = ""
            return
          }
          this.productsList[index].memberPrice = Number(item.memberPrice).toFixed(2)
        },
        // 参考进货价
        takePriceBlur(item, index) {
          if (item.takePrice == 0) {
            this.$message.error("参考进货价不能为0")
            this.productsList[index].takePrice = ""
            return
          }
          this.productsList[index].takePrice = Number(item.takePrice).toFixed(2)
        },
        // 库存数
        beginStockNumBlur(item, index) {
          if (item.beginStockNum == 0) {
            this.$message.error("库存数量不能为0")
            this.productsList[index].beginStockNum = ""
            return
          }
          this.productsList[index].beginStockNum = Number(item.beginStockNum).toFixed(3)
        }
    }
}
</script>

<style scoped>
.warn {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  margin-left: 5px;
  margin-right: 10px;
}
.mt20 {
  margin-top: 20px;
}
.ml30 {
  margin-left: 30px;
}
.ml140 {
  margin-left: 140px;
}
.ml90 {
  margin-left: 90px;
}
.flex-between {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
}
.flex-betweens {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
}
.flex-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.specification {
  width:915px;
  height:154px;
  background:rgba(247,247,247,1);
  padding: 20px;
  margin-top: 20px;
}
.searchGroup {
    position: absolute;
    top: 120px;
    padding-left: 25px;
    box-sizing: border-box;
}
.el-radio {
  margin-right: 0!important;
}
</style>
<style>
.hide .el-upload--picture-card {
  display: none;
}
.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// src/components/page/chooseAddGoods.vue